import Link from "next/link";
import { Waves } from "lucide-react";
import styles from "./home-scroll-header.module.css";

export function HomeScrollHeader({ visible }: { visible: boolean }) {
  return (
    <header
      className={`${styles.header} ${visible ? styles.visible : ""}`}
      aria-hidden={!visible}
    >
      <Link
        className={styles.brand}
        href="#top"
        tabIndex={visible ? 0 : -1}
      >
        <span className="brand-mark" aria-hidden="true">
          <Waves />
        </span>
        <strong>Boardblend</strong>
      </Link>
      <nav aria-label="Homepage">
        <Link href="#product" tabIndex={visible ? 0 : -1}>
          How it works
        </Link>
        <Link href="#examples" tabIndex={visible ? 0 : -1}>
          Examples
        </Link>
        <Link href="#pricing" tabIndex={visible ? 0 : -1}>
          Pricing
        </Link>
        <Link href="#faq" tabIndex={visible ? 0 : -1}>
          FAQ
        </Link>
        <Link
          className={styles.signIn}
          href="/sign-in"
          tabIndex={visible ? 0 : -1}
        >
          Sign in
        </Link>
      </nav>
    </header>
  );
}
